import { render, staticRenderFns } from "./SearchTariffPage.vue?vue&type=template&id=48eb2a63&scoped=true&"
import script from "./SearchTariffPage.vue?vue&type=script&lang=js&"
export * from "./SearchTariffPage.vue?vue&type=script&lang=js&"
import style0 from "./SearchTariffPage.vue?vue&type=style&index=0&id=48eb2a63&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eb2a63",
  null
  
)

export default component.exports